import 'vite/modulepreload-polyfill'

import on from 'dom-event'
import '@/js/lib/accessibility'
import init from '@/js/lib/init'
import { set, isIEorEdge } from '@/js/lib/util'
import { pushOnQuizLinksClick } from '@/js/lib/datalayer'
import '@/js/lib/global-events'

document.addEventListener('DOMContentLoaded', () => {
  if (isIEorEdge()) set(document.body, 'ie')
  if (window.SENTRY?.enabled) {
    Sentry.init({
      dsn: 'https://' + window.SENTRY.dsn
    })
  }
  init().mount()
  on(document.body, 'WheelBarrow.ReInitModules', (data) => {
    init('modules', data.detail).mount()
  })

  pushOnQuizLinksClick()
})
